import React from "react";
import { Link } from "react-router-dom";
import { FaClock, FaCheck, FaArrowRight } from "react-icons/fa";
import "./ServicesP.css";

const services = [
  {
    title: "Luxury Hand Wash",
    duration: "30 min",
    description:
      "High-quality hand wash, foam bath, exterior windows, door jambs, minor bug removal, wheel & tire dressing, and a hand dry with ultra-plush microfiber towels.",
    prices: { Car: "$45", Truck: "$65", SUV: "$65", Van: "$65" },
    image: require("../../imgs/services/service1.jpg"),
  },
  {
    title: "Complete Interior",
    duration: "1.5 hr",
    description:
      "Express interior, clean and shampoo of upholstery and carpets, door jambs, plus console and glove-box cleaning.",
    prices: { Car: "$150", Truck: "$175", SUV: "$200", Van: "$200" },
    image: require("../../imgs/services/seats.jpg"),
  },
  {
    title: "Complete Basic Detail",
    duration: "1.5 hr",
    description:
      "Hand wash, express interior, orbital high-speed wax, door jambs, and dash, console & glove-box cleaning.",
    prices: { Car: "$200", Truck: "$300", SUV: "$375", Van: "$375" },
    image: require("../../imgs/services/service3.jpg"),
  },
  {
    title: "Ultimate Enhancement",
    duration: "2 hr",
    description:
      "Complete basic detail plus high-speed buff & polish, hand wax, interior shampoo, and basic engine cleaning.",
    prices: { Car: "$300", Truck: "$400", SUV: "$500", Van: "$500" },
    image: require("../../imgs/services/polish.jpg"),
    featured: true,
  },
];

const additionalServices = [
  "Headlight Restoration",
  "Tar & Stain Removal",
  "Clay Bar Work",
  "Odor Removal (fabric & vents)",
];

const ServicesP = () => {
  return (
    <>
      <header className="services-hero">
        <div className="services-hero-overlay" />
        <div className="services-hero-content">
          <p className="services-eyebrow">JG Detailing</p>
          <h1>Our Services</h1>
          <p className="services-sub">
            Professional detailing packages for every vehicle — from a quick luxury wash to a full showroom-level enhancement.
          </p>
          <Link to="/booking" className="services-hero-btn">Book an Appointment <FaArrowRight /></Link>
        </div>
      </header>

      <section className="services-section">
        <div className="svc-grid">
          {services.map((s, i) => (
            <article className={`svc-card ${s.featured ? "featured" : ""}`} key={i}>
              {s.featured && <span className="svc-badge">Most Popular</span>}
              <div className="svc-media">
                <img src={s.image} alt={s.title} loading="lazy" decoding="async" />
              </div>
              <div className="svc-body">
                <div className="svc-head">
                  <h3>{s.title}</h3>
                  <span className="svc-duration"><FaClock /> {s.duration}</span>
                </div>
                <p className="svc-desc">{s.description}</p>

                <div className="svc-prices">
                  {Object.entries(s.prices).map(([k, v]) => (
                    <div className="svc-price" key={k}>
                      <span>{k}</span>
                      <strong>{v}</strong>
                    </div>
                  ))}
                </div>

                <Link to="/booking" className="svc-book">Book this service <FaArrowRight /></Link>
              </div>
            </article>
          ))}
        </div>

        <div className="svc-extras">
          <h3>Add-on Services</h3>
          <p className="svc-extras-sub">Enhance any package with these extras — just ask when you book.</p>
          <div className="svc-extras-grid">
            {additionalServices.map((item, i) => (
              <div className="svc-extra" key={i}><FaCheck /> {item}</div>
            ))}
          </div>
        </div>

        <div className="svc-cta">
          <div>
            <h3>Not sure which package fits?</h3>
            <p>Tell us about your vehicle and we’ll recommend the right detail.</p>
          </div>
          <div className="svc-cta-actions">
            <Link to="/contact" className="svc-cta-primary">Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesP;
